import React, { useState, useEffect } from "react";
import {
  TextField,
  Grid,
  IconButton,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Divider,
  Switch,
  Card,
  CircularProgress,
  Fade,
} from "@mui/material";
import MDButton from "components/MDButton";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { telemetry } from "globals/endpoints";
import { useMaterialUIController } from "context";
import { application } from "globals/endpoints";
import CTLNotification from "application/components/CTLNotification";
import MDTypography from "components/MDTypography";
import AuthenticationService from "application/modules/authentication/AuthenticationService";
import MDBox from "components/MDBox";
import { makeStyles } from "@material-ui/core";
const initialForm = {
  account: [
    {
      accountNo: "1",
      label: AuthenticationService.getUserName() || "",
      extensionNo: AuthenticationService.getExtensionNumber() || "NA",
    },
  ],
  blf: [
    {
      key: "",
      type: "0",
      mode: "0",
      value: "",
      label: "",
      account: "",
      extension: AuthenticationService.getExtensionNumber() || "NA",
      extensionName: "",
      rluCode: "",
    },
  ],
  programmableKey: {
    softKey: [
      {
        name: "SoftKey 1",
        key: "1",
        type: "0",
        label: "",
        account: "",
        value: "",
      },
      {
        name: "SoftKey 2",
        key: "2",
        type: "0",
        label: "",
        account: "",
        value: "",
      },
      {
        name: "SoftKey 3",
        key: "3",
        type: "0",
        label: "",
        account: "",
        value: "",
      },
      {
        name: "SoftKey 4",
        key: "4",
        type: "0",
        label: "",
        account: "",
        value: "",
      },
    ],
    settingKey: [
      {
        label: "Up",
        key: "1",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Down",
        key: "2",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Left",
        key: "3",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Right",
        key: "4",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Ok",
        key: "5",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Cancel",
        key: "6",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Mute",
        key: "7",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "CONF",
        key: "8",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "TRAN",
        key: "9",
        type: "0",
        account: "",
        value: "",
      },
      {
        label: "Hold",
        key: "10",
        type: "0",
        account: "",
        value: "",
      },
    ],
    settingSingleKey: [
      {
        label: "Speaker",
        key: "1",
        active: "0",
      },
      {
        label: "Headset",
        key: "2",
        active: "0",
      },
      {
        label: "VM",
        key: "3",
        active: "0",
      },
      {
        label: "Volume Up",
        key: "4",
        active: "0",
      },
      {
        label: "Volume Down",
        key: "5",
        active: "0",
      },
      {
        label: "Redial",
        key: "6",
        active: "0",
      },
    ],
  },
};

const typeMenu = [
  { value: "0", type: "N/A" },
  { value: "1", type: "Line" },
  { value: "2", type: "Speed Dial" },
  { value: "3", type: "BLF" },
  { value: "4", type: "BLF List" },
  { value: "5", type: "Voice Mail" },
  { value: "6", type: "Direct Pickup" },
  { value: "7", type: "Group Pickup" },
  { value: "8", type: "Call Park" },
  { value: "9", type: "Intercom" },
  { value: "10", type: "DTMF" },
  { value: "11", type: "Prefix" },
  { value: "12", type: "Local Group" },
  { value: "13", type: "XML Group" },
  { value: "14", type: "XML Browser" },
  { value: "15", type: "LDAP" },
  { value: "16", type: "Network Directories" },
  { value: "17", type: "Conference" },
  { value: "18", type: "Forward" },
  { value: "19", type: "Transfer" },
  { value: "20", type: "Hold" },
  { value: "21", type: "DND" },
  { value: "22", type: "Redial" },
  { value: "23", type: "Call Return" },
  { value: "24", type: "SMS" },
  { value: "25", type: "Record" },
  { value: "26", type: "URL Record" },
  { value: "28", type: "Group Listening" },
  { value: "29", type: "Public Hold" },
  { value: "30", type: "Private Hold" },
  { value: "32", type: "Hot Desking" },
  { value: "33", type: "ACD" },
  { value: "34", type: "Zero Touch" },
  { value: "35", type: "URL" },
  { value: "44", type: "Network Group" },
  { value: "47", type: "MultiCast Paging" },
  { value: "51", type: "Group Call Park" },
  { value: "52", type: "CallPark Retrieve" },
  { value: "56", type: "XML BLF" },
  { value: "57", type: "Silent Call" },
  { value: "58", type: "Smart BLF" },
  { value: "62", type: "Contact" },
];

const softKeyMenu = [
  { action: "NV", value: "0", type: "N/A" },
  { action: "A", value: "2", type: "Speed Dial" },
  { action: "A", value: "6", type: "Direct Pickup" },
  { action: "A", value: "7", type: "Group Pickup" },
  { action: "A", value: "9", type: "Intercom" },
  { action: "N", value: "11", type: "Prefix" },
  { action: "NV", value: "12", type: "Local Group" },
  { action: "RV", value: "13", type: "XML Group" },
  { action: "N", value: "14", type: "XML Browser" },
  { action: "NV", value: "15", type: "LDAP" },
  { action: "NV", value: "16", type: "Network Directories" },
  { action: "N", value: "18", type: "Forward" },
  { action: "NV", value: "21", type: "DND" },
  { action: "NV", value: "22", type: "Redial" },
  { action: "NV", value: "23", type: "Call Return" },
  { action: "NV", value: "24", type: "SMS" },
  { action: "NV", value: "36", type: "History" },
  { action: "DV", value: "37", type: "Directory" },
  { action: "NV", value: "38", type: "Menu" },
  { action: "NV", value: "39", type: "New SMS" },
  { action: "NV", value: "40", type: "Phone Status" },
  { action: "NV", value: "41", type: "Switch Account Up" },
  { action: "NV", value: "42", type: "Switch Account Down" },
  { action: "A", value: "43", type: "Local Phone Book" },
  { action: "NG", value: "44", type: "Network Group" },
  { action: "N", value: "45", type: "XML Phone Book" },
  { action: "NV", value: "46", type: "Network Call Log" },
  { action: "A", value: "52", type: "Call Park Retrieve" },
  { action: "NV", value: "54", type: "Next Linekey Page" },
  { action: "NV", value: "55", type: "Pre Linekey Page" },
];

const settingKeyMenu = [
  { action: "NV", value: "0", type: "N/A" },
  { action: "A", value: "2", type: "Speed Dial" },
  { action: "A", value: "6", type: "Direct Pickup" },
  { action: "A", value: "7", type: "Group Pickup" },
  { action: "A", value: "9", type: "Intercom" },
  { action: "N", value: "11", type: "Prefix" },
  { action: "NV", value: "12", type: "Local Group" },
  { action: "RV", value: "13", type: "XML Group" },
  { action: "N", value: "14", type: "XML Browser" },
  { action: "NV", value: "15", type: "LDAP" },
  { action: "NV", value: "16", type: "Network Directories" },
  { action: "N", value: "18", type: "Forward" },
  { action: "NV", value: "21", type: "DND" },
  { action: "NV", value: "22", type: "Redial" },
  { action: "NV", value: "23", type: "Call Return" },
  { action: "NV", value: "24", type: "SMS" },
  { action: "NV", value: "36", type: "History" },
  { action: "DV", value: "37", type: "Directory" },
  { action: "NV", value: "38", type: "Menu" },
  { action: "NV", value: "39", type: "New SMS" },
  { action: "NV", value: "40", type: "Phone Status" },
  { action: "NV", value: "41", type: "Switch Account Up" },
  { action: "NV", value: "42", type: "Switch Account Down" },
  { action: "A", value: "43", type: "Local Phone Book" },
  { action: "NG", value: "44", type: "Network Group" },
  { action: "N", value: "45", type: "XML Phone Book" },
  { action: "NV", value: "46", type: "Network Call Log" },
];

const networkGroupMenu = [
  { value: "50", type: "All Contacts" },
  { value: "51", type: "Group" },
  { value: "52", type: "Interoperability" },
  { value: "53", type: "Group Common" },
  { value: "54", type: "Enterprise Common" },
  { value: "55", type: "Personal" },
  { value: "56", type: "Custom Directories" },
];

const remotePhoneBookMenu = [
  { value: "60", type: "Remote Phonebook 1" },
  { value: "61", type: "Remote Phonebook 2" },
  { value: "62", type: "Remote Phonebook 3" },
  { value: "63", type: "Remote Phonebook 4" },
  { value: "64", type: "Remote Phonebook 5" },
];

const directoryMenu = [
  { value: "70", type: "Menu View" },
  { value: "72", type: "Local Contacts" },
  { value: "80", type: "LDAP Contacts" },
];

const accountOptions = [
  { value: "0", type: "Account 1" },
  { value: "1", type: "Account 2" },
  { value: "2", type: "Account 3" },
  { value: "3", type: "Account 4" },
  { value: "4", type: "Account 5" },
  { value: "5", type: "Account 6" },
  { value: "6", type: "Account 7" },
  { value: "7", type: "Account 8" },
  { value: "8", type: "Account 9" },
  { value: "9", type: "Account 10" },
  { value: "A", type: "Account 11" },
  { value: "B", type: "Account 12" },
  { value: "C", type: "Account 13" },
  { value: "D", type: "Account 14" },
  { value: "E", type: "Account 15" },
  { value: "F", type: "Account 16" },
];

const accountLineKeys = Array.from({ length: 16 }, (_, i) => i + 1);

const parseProvisioningString = (str) => {
  if (!str) return null;

  try {
    // Parse account section
    const accountMatches = str.match(/Account\(([^)]+)\)/g) || [];
    const account = accountMatches.map((acc) => ({
      accountNo: acc.match(/accountNo=([^,\s]+)/)?.[1] || "1",
      label: acc.match(/label=([^,\s)]+)/)?.[1] || "",
      extensionNo: acc.match(/extensionNo=([^,\s)]+)/)?.[1] || "NA",
    }));

    // Parse BLF section
    const blfMatches = str.match(/Blf\(([^)]+(?:\([^)]*\))?[^)]*)\)/g) || [];
    const blf = blfMatches.map((b) => ({
      key: b.match(/key=([^,\s]+)/)?.[1] || "",
      type: b.match(/type=([^,\s]+)/)?.[1] || "0",
      mode: b.match(/mode=([^,\s]+)/)?.[1] || "0",
      value: b.match(/value=([^,\s)]+)/)?.[1] || "",
      label: b.match(/label=([^,\s)]+)/)?.[1] || "NA",
      account: b.match(/account=([^,\s]+)/)?.[1] || "",
      extension: b.match(/extension=([^,\s)]+)/)?.[1] || "NA",
    }));

    // Parse SoftKey section
    const softKeyMatches = str.match(/SoftKey\(([^)]+)\)/g) || [];
    const softKey = softKeyMatches.map((sk, idx) => ({
      name: `SoftKey ${idx + 1}`,
      key: `${idx + 1}`,
      type: sk.match(/type=([^,\s]+)/)?.[1] || "0",
      label: sk.match(/label=([^,)]*)/)?.[1] || "",
      account: sk.match(/account=([^,\s]+)/)?.[1] || "",
      value: sk.match(/value=([^,)]*)/)?.[1] || "",
    }));

    // Parse SettingKey section
    const settingKeyMatches = str.match(/SettingKey\(([^)]+)\)/g) || [];
    const settingKeyLabels = [
      "Up",
      "Down",
      "Left",
      "Right",
      "Ok",
      "Cancel",
      "Mute",
      "CONF",
      "TRAN",
      "Hold",
    ];
    const settingKey = settingKeyMatches.map((sk, idx) => ({
      label: settingKeyLabels[idx] || `Setting ${idx + 1}`,
      key: `${idx + 1}`,
      type: sk.match(/type=([^,\s]+)/)?.[1] || "0",
      account: sk.match(/account=([^,\s]+)/)?.[1] || "",
      value: sk.match(/value=([^,)]*)/)?.[1] || "",
    }));

    // Parse SettingSingleKey section
    const settingSingleKeyMatches =
      str.match(/SettingSingleKey\(([^)]+)\)/g) || [];
    const settingSingleKeyLabels = [
      "Speaker",
      "Headset",
      "VM",
      "Volume Up",
      "Volume Down",
      "Redial",
    ];
    const settingSingleKey = settingSingleKeyMatches.map((ssk, idx) => ({
      label: settingSingleKeyLabels[idx] || `Setting ${idx + 1}`,
      key: `${idx + 1}`,
      active: ssk.match(/active=([^,\s)]+)/)?.[1] || "0",
    }));

    return {
      account: account.length > 0 ? account : null,
      blf: blf.length > 0 ? blf : null,
      programmableKey: {
        softKey: softKey.length > 0 ? softKey : null,
        settingKey: settingKey.length > 0 ? settingKey : null,
        settingSingleKey: settingSingleKey.length > 0 ? settingSingleKey : null,
      },
    };
  } catch (err) {
    console.error("Provisioning parse error:", err);
    return null;
  }
};

const useStyles = makeStyles(() => ({
  loadingOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
}));

const ExtensionConfiguration = () => {
  const number = AuthenticationService.getExtensionNumber();
  const name = AuthenticationService.getUserName();
  const pageName = "Extension Configuration";
  const [maxAccounts, setMaxAccounts] = useState(16);
  const [formData, setFormData] = useState(initialForm);
  const [extensionList, setExtensionList] = useState([]);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [ipAddress, setIpAddress] = useState("");
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    pagename: "",
    status: "",
  });

  const keyMenu = Array.from({ length: 36 }, (_, i) => ({
    value: i + 1,
    label: `Key ${i + 1}`,
  }));

  useEffect(() => {
    if (number) {
      getExtensionList();
      fetchConfig(number);
    }
  }, [number, name]);

  // ---------------- Extension List ----------------
  const getExtensionList = async () => {
    try {
      const response = await application.post(
        "extensions/listAllExtnsionType",
        {
          requestExtensionType: ["phone", "agent", "softphone"],
        },
      );

      if (response?.data?.data) {
        setExtensionList(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching extension list:", error);
      setExtensionList([]);
    }
  };

  const fetchConfig = async (number) => {
    setLoading(true);
    try {
      const response = await telemetry.post(
        `deviceManager/get/configuration/uc/${number}`,
      );

      const data = response.data.data?.[0];
      const parsed = parseProvisioningString(data?.deviceDetailsProvisioning);
      setIpAddress(data?.macAddress || "");

      if (parsed) {
        setFormData({
          account: parsed.account || initialForm.account,
          blf: parsed.blf || initialForm.blf,
          programmableKey: {
            softKey:
              parsed.programmableKey?.softKey ||
              initialForm.programmableKey.softKey,
            settingKey:
              parsed.programmableKey?.settingKey ||
              initialForm.programmableKey.settingKey,
            settingSingleKey:
              parsed.programmableKey?.settingSingleKey ||
              initialForm.programmableKey.settingSingleKey,
          },
        });
      } else {
        resetFormData();
      }
    } catch (error) {
      console.error("Error loading config:", error);
      setIpAddress("");
      resetFormData();
    } finally {
      setLoading(false);
    }
  };

  // Reset form to initial state
  const resetFormData = () => {
    setFormData(JSON.parse(JSON.stringify(initialForm)));
    setNotify({
      isOpen: true,
      message: "Form reset to default",
      type: "info",
      pagename: pageName,
      status: "Form state reset successfully",
    });
  };

  const menuProps = {
    PaperProps: { style: { maxHeight: 200 } },
  };

  // ---------------- Submit ----------------
  const handleSubmit = () => {
    // Validate account data
    if (!formData.account || formData.account.length === 0) {
      setNotify({
        pagename: pageName,
        isOpen: true,
        message: "",
        type: "warning",
        status: "Account information is missing. Please load config first.",
      });
      return;
    }

    const finalPayload = {
      account: formData.account.map((acc) => ({
        accountNo: acc.accountNo || "1",
        label: acc.label || "",
        extensionNo: acc.extensionNo || "NA",
      })),
      blf: formData.blf
        // .filter((b) => b.key && b.type && b.type !== "0") // Filter empty entries
        .map((b) => ({
          key: b.key,
          type: b.type,
          mode: b.mode || "0",
          value: b.value || "",
          label: b.label || "",
          account: b.account || "",
          extension: b.extension ? b.extension : "NA",
        })),
      programmableKey: {
        softKey: formData.programmableKey.softKey.map((sk) => ({
          key: sk.key,
          type: sk.type || "0",
          label: sk.label || "",
          account: sk.account || "",
          value: sk.value || "",
        })),
        settingKey: formData.programmableKey.settingKey.map((setk) => ({
          key: setk.key,
          type: setk.type || "0",
          account: setk.account || "",
          value: setk.value || "",
        })),
        settingSingleKey: formData.programmableKey.settingSingleKey.map(
          (ssk) => ({
            key: ssk.key,
            active: ssk.active || "0",
          }),
        ),
      },
    };

    onSubmit(finalPayload);
    console.log("Final Payload:", finalPayload);
  };

  const onSubmit = async (payload) => {
    setLoading(true);

    if (
      !payload.account ||
      !payload.account[0] ||
      !payload.account[0].extensionNo ||
      payload.account[0].extensionNo === "NA"
    ) {
      setNotify({
        pagename: pageName,
        isOpen: true,
        message: "",
        type: "warning",
        status: "Extension Number Not Found. Please Save User Profile first.",
      });

      setLoading(false);
      return;
    }

    try {
      const extensionNo = payload.account[0].extensionNo;
      const response = await telemetry.post(
        `deviceManager/update/configuration/uc/${extensionNo}`,
        payload,
      );

      if (response?.data?.status === 0 || response?.data?.issue === "OK") {
        setNotify({
          isOpen: true,
          message: response.data?.message || "Success",
          type: "success",
          pagename: pageName,
          status: "Configuration updated successfully",
        });
        // Reload config after successful update
        setTimeout(() => {
          fetchConfig(extensionNo);
        }, 1000);
      } else {
        setNotify({
          isOpen: true,
          message: response.data?.message || "Error",
          type: "error",
          pagename: pageName,
          status: response.data?.messageDetail || "Configuration update failed",
        });
      }
    } catch (error) {
      console.error("Submit error:", error);
      setNotify({
        isOpen: true,
        message: error?.response?.data?.message || "Error",
        type: "error",
        pagename: pageName,
        status:
          error?.response?.data?.messageDetail ||
          "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  // ---------------- BLF HANDLERS ----------------
  const updateBLF = (i, field, value) => {
    const updated = [...formData.blf];
    updated[i][field] = value;
    setFormData({ ...formData, blf: updated });
  };

  const addBLF = () => {
    if (formData.blf.length >= 36) {
      alert("You can add a maximum of 36 Line Key entries.");
      return;
    }

    setFormData({
      ...formData,
      blf: [
        ...formData.blf,
        {
          key: "",
          type: "0",
          mode: "0",
          value: "",
          label: "",
          account: 0,
          extension: AuthenticationService.getExtensionNumber() || "NA",
          extensionName: "",
          rluCode: "",
        },
      ],
    });
  };

  const removeBLF = (i) => {
    const updated = [...formData.blf];
    updated.splice(i, 1);
    setFormData({ ...formData, blf: updated });
  };

  const updateSoftKey = (index, field, value) => {
    const updated = [...formData.programmableKey.softKey];
    updated[index][field] = value;

    setFormData({
      ...formData,
      programmableKey: {
        ...formData.programmableKey,
        softKey: updated,
      },
    });
  };

  const updateSettingKey = (index, field, value) => {
    const updated = [...formData.programmableKey.settingKey];
    updated[index][field] = value;

    setFormData({
      ...formData,
      programmableKey: {
        ...formData.programmableKey,
        settingKey: updated,
      },
    });
  };

  const updateSingleKey = (index, value) => {
    const updated = [...formData.programmableKey.settingSingleKey];
    updated[index].active = value ? "1" : "0";

    setFormData({
      ...formData,
      programmableKey: {
        ...formData.programmableKey,
        settingSingleKey: updated,
      },
    });
  };

  const getSoftKeyAction = (type) => {
    return softKeyMenu.find((x) => x.value === type)?.action;
  };

  const getSettingKeyAction = (type) => {
    return settingKeyMenu.find((x) => x.value === type)?.action;
  };

  const getAccountMenuByAction = (action) => {
    if (action === "RV") return remotePhoneBookMenu;
    if (action === "DV") return directoryMenu;
    if (action === "NG") return networkGroupMenu;
    return accountOptions;
  };

  return (
    <MDBox sx={{ p: 2 }}>
      {/* Header Card */}
      <Card
        sx={{
          mb: 3,
          p: 3,
          color: "white",
          background: darkMode
            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
            : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)",
          borderRadius: "12px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 3,
          }}
        >
          <Box>
            <MDTypography variant="h3" fontWeight="bold" sx={{ mb: 1 }}>
              Extension Configuration
            </MDTypography>
            <MDTypography variant="subtitle2" sx={{ opacity: 0.9 }}>
              Manage your phone extension settings
            </MDTypography>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <MDTypography variant="subtitle2" sx={{ opacity: 0.8, mb: 0.5 }}>
              Extension
            </MDTypography>
            <MDTypography variant="h5" fontWeight="bold">
              {AuthenticationService.getExtensionNumber() || "N/A"}
            </MDTypography>
          </Box>

          <Box sx={{ textAlign: "right" }}>
            <MDTypography variant="subtitle2" sx={{ opacity: 0.8, mb: 0.5 }}>
              Device Mac Address
            </MDTypography>
            <MDTypography variant="h5" fontWeight="bold">
              {ipAddress || "Offline"}
            </MDTypography>
          </Box>
        </Box>
      </Card>
      {ipAddress ? (
        <>
          {/* Line Key Card */}
          <Card
            sx={{
              mt: 3,
              mb: 3,
              p: 3,
              boxShadow: darkMode
                ? "0 4px 20px 0 rgba(0, 0, 0, 0.3)"
                : "0 4px 20px 0 rgba(0, 0, 0, 0.1)",
              borderRadius: "12px",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 3,
                pb: 2,
                borderBottom: darkMode
                  ? "2px solid rgba(255, 255, 255, 0.1)"
                  : "2px solid #f0f0f0",
              }}
            >
              <Box
                sx={{
                  width: "4px",
                  height: "30px",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  borderRadius: "2px",
                }}
              />
              <MDTypography variant="h4" fontWeight="bold">
                Line Key Configuration
              </MDTypography>
            </Box>

            {formData.blf.map((b, i) => (
              <Box
                key={i}
                mt={2}
                sx={{
                  p: 2,
                  borderRadius: "8px",
                  border: darkMode
                    ? "1px solid rgba(255, 255, 255, 0.1)"
                    : "1px solid #e9ecef",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: darkMode
                      ? "0 2px 8px rgba(255, 255, 255, 0.1)"
                      : "0 2px 8px rgba(0,0,0,0.08)",
                  },
                }}
              >
                <Grid container spacing={2}>
                  {/* Key */}
                  <Grid item xs={1.8}>
                    <FormControl fullWidth>
                      <InputLabel>Key</InputLabel>
                      <Select
                        sx={{ minHeight: "45px" }}
                        value={b.key || ""}
                        label="Key"
                        MenuProps={menuProps}
                        onChange={(e) => {
                          updateBLF(i, "key", e.target.value);
                        }}
                      >
                        {keyMenu.map((item, index) => (
                          <MenuItem key={index} value={item.value}>
                            {item.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Type */}
                  <Grid item xs={1.8}>
                    <FormControl fullWidth>
                      <InputLabel>Type</InputLabel>
                      <Select
                        sx={{ minHeight: "45px" }}
                        value={b.type}
                        label="Type"
                        MenuProps={menuProps}
                        onChange={(e) => {
                          updateBLF(i, "type", e.target.value);
                        }}
                      >
                        {typeMenu.map((item, index) => (
                          <MenuItem key={index} value={item.value}>
                            {item.type}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Value */}
                  <Grid item xs={1.8}>
                    <TextField
                      label="Value"
                      fullWidth
                      value={b.value}
                      onChange={(e) => updateBLF(i, "value", e.target.value)}
                    />
                  </Grid>

                  {/* Label */}
                  <Grid item xs={1.8}>
                    <TextField
                      label="Label"
                      fullWidth
                      value={b.label}
                      onChange={(e) => updateBLF(i, "label", e.target.value)}
                    />
                  </Grid>

                  {/* Account */}
                  <Grid item xs={1.8}>
                    <FormControl fullWidth>
                      <InputLabel>Account</InputLabel>
                      <Select
                        sx={{ minHeight: "45px" }}
                        value={b.account}
                        label="Account"
                        MenuProps={menuProps}
                        onChange={(e) =>
                          updateBLF(i, "account", e.target.value)
                        }
                      >
                        <MenuItem value={""}>Select Account</MenuItem>
                        {accountLineKeys.map((num, index) => (
                          <MenuItem key={index} value={num}>
                            Account {num}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Extension */}
                  <Grid item xs={1.8}>
                    <TextField
                      label="Extension"
                      fullWidth
                      variant="outlined"
                      value={b.extension}
                      // onChange={(e) => updateBLF(i, "extension", e.target.value)}
                      readOnly
                    />
                  </Grid>

                  {/* Delete */}
                  <Grid item xs={1.2}>
                    <IconButton color="error" onClick={() => removeBLF(i)}>
                      <RemoveCircleOutlineIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Box>
            ))}

            <MDButton
              color="info"
              variant="contained"
              size="small"
              sx={{
                mt: 2,
                px: 2.5,
                py: 1,
                fontSize: "0.85rem",
                textTransform: "none",
                borderRadius: "8px",
                fontWeight: 600,
                background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 6px 16px rgba(102, 126, 234, 0.4)",
                  transform: "translateY(-2px)",
                },
              }}
              onClick={addBLF}
            >
              + Add Line Key
            </MDButton>
          </Card>

          {/* Programmable Key Card */}
          <Card
            sx={{
              mt: 3,
              mb: 3,
              p: 3,
              boxShadow: darkMode
                ? "0 4px 20px 0 rgba(0, 0, 0, 0.3)"
                : "0 4px 20px 0 rgba(0, 0, 0, 0.1)",
              borderRadius: "12px",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 3,
                pb: 2,
                borderBottom: darkMode
                  ? "2px solid rgba(255, 255, 255, 0.1)"
                  : "2px solid #f0f0f0",
              }}
            >
              <Box
                sx={{
                  width: "4px",
                  height: "30px",
                  background:
                    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                  borderRadius: "2px",
                }}
              />
              <MDTypography variant="h4" fontWeight="bold">
                Programmable Key Configuration
              </MDTypography>
            </Box>

            {formData.programmableKey?.softKey.map((b, i) => {
              const action = getSoftKeyAction(b.type);

              const disableAccount = action === "N" || action === "NV";
              const disableValue =
                action === "NV" ||
                action === "RV" ||
                action === "DV" ||
                action === "NG";
              const accountMenu = getAccountMenuByAction(action);

              return (
                <Box
                  key={i}
                  mt={2}
                  sx={{
                    p: 2,
                    borderRadius: "8px",
                    border: darkMode
                      ? "1px solid rgba(255, 255, 255, 0.1)"
                      : "1px solid #e9ecef",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: darkMode
                        ? "0 2px 8px rgba(255, 255, 255, 0.1)"
                        : "0 2px 8px rgba(0,0,0,0.08)",
                    },
                  }}
                >
                  <Grid container spacing={2}>
                    <Grid item xs={2}>
                      <MDTypography>{b.name}</MDTypography>
                    </Grid>

                    <Grid item xs={2.2}>
                      <FormControl fullWidth>
                        <InputLabel>Type</InputLabel>
                        <Select
                          sx={{ minHeight: "45px" }}
                          MenuProps={menuProps}
                          value={b.type}
                          label="Type"
                          onChange={(e) => {
                            updateSoftKey(i, "type", e.target.value);
                            updateSoftKey(i, "account", "");
                            updateSoftKey(i, "value", "");
                          }}
                        >
                          {softKeyMenu.map((t) => (
                            <MenuItem key={t.value} value={t.value}>
                              {t.type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={2.2}>
                      <TextField
                        label="Label"
                        fullWidth
                        value={b.label}
                        onChange={(e) =>
                          updateSoftKey(i, "label", e.target.value)
                        }
                      />
                    </Grid>

                    <Grid item xs={2.2}>
                      <FormControl fullWidth>
                        <InputLabel disabled={disableAccount}>
                          Account
                        </InputLabel>
                        <Select
                          disabled={disableAccount}
                          sx={{ minHeight: "45px" }}
                          MenuProps={menuProps}
                          value={b.account}
                          label="Account"
                          onChange={(e) =>
                            updateSoftKey(i, "account", e.target.value)
                          }
                        >
                          <MenuItem value="">Select</MenuItem>
                          {accountMenu.map((num, index) => (
                            <MenuItem key={index} value={num.value}>
                              {num.type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={2.2}>
                      <TextField
                        disabled={disableValue}
                        label="Value"
                        fullWidth
                        value={b.value}
                        onChange={(e) =>
                          updateSoftKey(i, "value", e.target.value)
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>
              );
            })}

            {formData.programmableKey?.settingKey.map((b, i) => {
              const action = getSettingKeyAction(b.type);

              const disableAccount = action === "N" || action === "NV";
              const disableValue =
                action === "NV" ||
                action === "RV" ||
                action === "DV" ||
                action === "NG";
              const accountMenu = getAccountMenuByAction(action);

              return (
                <Box
                  key={i}
                  mt={2}
                  sx={{
                    p: 2,
                    borderRadius: "8px",
                    border: darkMode
                      ? "1px solid rgba(255, 255, 255, 0.1)"
                      : "1px solid #e9ecef",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      boxShadow: darkMode
                        ? "0 2px 8px rgba(255, 255, 255, 0.1)"
                        : "0 2px 8px rgba(0,0,0,0.08)",
                    },
                  }}
                >
                  <Grid container spacing={1}>
                    <Grid item xs={2}>
                      <MDTypography>{b.label}</MDTypography>
                    </Grid>

                    <Grid item xs={2.9}>
                      <FormControl fullWidth>
                        <InputLabel>Type</InputLabel>
                        <Select
                          sx={{ minHeight: "45px" }}
                          MenuProps={menuProps}
                          value={b.type}
                          label="Type"
                          onChange={(e) => {
                            updateSettingKey(i, "type", e.target.value);
                            updateSettingKey(i, "account", "");
                            updateSettingKey(i, "value", "");
                          }}
                        >
                          {settingKeyMenu.map((t) => (
                            <MenuItem key={t.value} value={t.value}>
                              {t.type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={2.9}>
                      <FormControl fullWidth>
                        <InputLabel disabled={disableAccount}>
                          Account
                        </InputLabel>
                        <Select
                          disabled={disableAccount}
                          sx={{ minHeight: "45px" }}
                          MenuProps={menuProps}
                          value={b.account}
                          label="Account"
                          onChange={(e) =>
                            updateSettingKey(i, "account", e.target.value)
                          }
                        >
                          <MenuItem value="">Select</MenuItem>
                          {accountMenu.map((num, index) => (
                            <MenuItem key={index} value={num.value}>
                              {num.type}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={2.9}>
                      <TextField
                        disabled={disableValue}
                        label="Value"
                        fullWidth
                        value={b.value}
                        onChange={(e) =>
                          updateSettingKey(i, "value", e.target.value)
                        }
                      />
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
          </Card>

          {/* Single Key Controls Card */}
          <Card
            sx={{
              mt: 3,
              mb: 3,
              p: 3,
              boxShadow: darkMode
                ? "0 4px 20px 0 rgba(0, 0, 0, 0.3)"
                : "0 4px 20px 0 rgba(0, 0, 0, 0.1)",
              borderRadius: "12px",
              border: darkMode
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                mb: 3,
                pb: 2,
                borderBottom: darkMode
                  ? "2px solid rgba(255, 255, 255, 0.1)"
                  : "2px solid #f0f0f0",
              }}
            >
              <Box
                sx={{
                  width: "4px",
                  height: "30px",
                  background:
                    "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
                  borderRadius: "2px",
                }}
              />
              <MDTypography
                variant="h4"
                fontWeight="bold"
                sx={{ color: darkMode ? "#fff" : "#333" }}
              >
                Single Key Controls
              </MDTypography>
            </Box>

            <Grid container spacing={3} alignItems="center">
              {formData.programmableKey?.settingSingleKey.map((b, i) => (
                <React.Fragment key={i}>
                  <Grid item xs={12} sm={6} md={2.4}>
                    <MDTypography
                      variant="subtitle2"
                      fontWeight="600"
                      sx={{ color: darkMode ? "#e0e0e0" : "#333" }}
                    >
                      {b.label}
                    </MDTypography>
                  </Grid>

                  <Grid item xs={12} sm={6} md={1.8}>
                    <Switch
                      checked={b.active === "1"}
                      onChange={(e) => updateSingleKey(i, e.target.checked)}
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#667eea",
                        },
                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                          {
                            backgroundColor: "#667eea",
                          },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6} md={1.8}>
                    <MDTypography
                      variant="caption"
                      sx={{
                        px: 1.5,
                        py: 0.75,
                        background:
                          b.active === "1"
                            ? darkMode
                              ? "#1e3a20"
                              : "#d4edda"
                            : darkMode
                              ? "#3a1e1e"
                              : "#f8d7da",
                        color: b.active === "1" ? "#4caf50" : "#ff6b6b",
                        borderRadius: "6px",
                        fontWeight: 600,
                        display: "inline-block",
                      }}
                    >
                      {b.active === "1" ? "Enabled" : "Disabled"}
                    </MDTypography>
                  </Grid>
                </React.Fragment>
              ))}
            </Grid>
          </Card>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 4,
              pt: 3,
              borderTop: darkMode
                ? "1px solid rgba(255, 255, 255, 0.1)"
                : "1px solid #e9ecef",
            }}
          >
            <MDButton
              variant="contained"
              color="secondary"
              sx={{
                px: 3,
                py: 1.2,
                fontSize: "0.95rem",
                fontWeight: 600,
                borderRadius: "8px",
                textTransform: "none",
                transition: "all 0.3s ease",
                "&:hover": {
                  background: darkMode ? "#4a4a5a" : "#5a6268",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  transform: "translateY(-2px)",
                },
              }}
              onClick={resetFormData}
            >
              Reset Form
            </MDButton>
            <MDButton
              variant="contained"
              color="info"
              sx={{
                px: 3,
                py: 1.2,
                fontSize: "0.95rem",
                fontWeight: 600,
                borderRadius: "8px",
                textTransform: "none",
                boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 6px 16px rgba(102, 126, 234, 0.4)",
                  transform: "translateY(-2px)",
                },
              }}
              onClick={handleSubmit}
            >
              Save Configuration
            </MDButton>
          </Box>
        </>
      ) : (
        <>
          <Card
            sx={{
              mt: 4,
              mb: 2,
              p: 4,
              boxShadow: "0 8px 32px 0 rgba(253, 203, 110, 0.3)",
              borderRadius: "12px",
              border: "1px solid rgba(0, 0, 0, 0.05)",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: 2,
                textAlign: "center",
              }}
            >
              <Box
                sx={{
                  width: "80px",
                  height: "80px",
                  background: "rgba(255, 255, 255, 0.3)",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "40px",
                }}
              >
                ⚠️
              </Box>
              <MDTypography variant="h5" fontWeight="bold">
                Device is Offline
              </MDTypography>

              <MDTypography variant="body2" sx={{ maxWidth: "400px" }}>
                Please ensure the device is connected and provisioning has been
                completed successfully before making configuration changes.
              </MDTypography>
            </Box>
          </Card>
        </>
      )}

      <CTLNotification notify={notify} setNotify={setNotify} />
      {loading && (
        <div className={classes.loadingOverlay}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <CircularProgress color="info" size={60} />
            <MDTypography color="white" fontSize="16px">
              Extension Configuration Applying...
            </MDTypography>
          </Box>
        </div>
      )}
    </MDBox>
  );
};

export default ExtensionConfiguration;
